// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { SiteV3ClientGeneratedAddressUpsearchModel } from './siteV3ClientGeneratedAddressUpsearchModel.js';
import type { SiteV3ClientGeneratedContactRoleType } from './siteV3ClientGeneratedContactRoleType.js';
import type { SiteV3ClientGeneratedEmailAddressUpsearchModel } from './siteV3ClientGeneratedEmailAddressUpsearchModel.js';
import type { SiteV3ClientGeneratedPhoneUpsearchModel } from './siteV3ClientGeneratedPhoneUpsearchModel.js';
import type { SiteV3ClientGeneratedWebAddressUpsearchModel } from './siteV3ClientGeneratedWebAddressUpsearchModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class SiteV3ClientGeneratedContactUpsearchModel {
    'addresses': Array<SiteV3ClientGeneratedAddressUpsearchModel>;
    'emailAddresses': Array<SiteV3ClientGeneratedEmailAddressUpsearchModel>;
    'phoneNumbers': Array<SiteV3ClientGeneratedPhoneUpsearchModel>;
    'webAddresses': Array<SiteV3ClientGeneratedWebAddressUpsearchModel>;
    'contactId'?: number | null;
    'contactType'?: SiteV3ClientGeneratedContactRoleType;
    'firstName': string;
    'lastName': string;
    'occupationDescription': string;
    'isMainContact'?: boolean;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof SiteV3ClientGeneratedContactUpsearchModel>> = [
        {
            "name":     "addresses",
            "baseName": "addresses",
            "type":     "Array<SiteV3ClientGeneratedAddressUpsearchModel>"
        },
        {
            "name":     "emailAddresses",
            "baseName": "emailAddresses",
            "type":     "Array<SiteV3ClientGeneratedEmailAddressUpsearchModel>"
        },
        {
            "name":     "phoneNumbers",
            "baseName": "phoneNumbers",
            "type":     "Array<SiteV3ClientGeneratedPhoneUpsearchModel>"
        },
        {
            "name":     "webAddresses",
            "baseName": "webAddresses",
            "type":     "Array<SiteV3ClientGeneratedWebAddressUpsearchModel>"
        },
        {
            "name":     "contactId",
            "baseName": "contactId",
            "type":     "number"
        },
        {
            "name":     "contactType",
            "baseName": "contactType",
            "type":     "SiteV3ClientGeneratedContactRoleType"
        },
        {
            "name":     "firstName",
            "baseName": "firstName",
            "type":     "string"
        },
        {
            "name":     "lastName",
            "baseName": "lastName",
            "type":     "string"
        },
        {
            "name":     "occupationDescription",
            "baseName": "occupationDescription",
            "type":     "string"
        },
        {
            "name":     "isMainContact",
            "baseName": "isMainContact",
            "type":     "boolean"
        },
    ];

    static getAttributeTypeMap() {
        return SiteV3ClientGeneratedContactUpsearchModel.attributeTypeMap;
    }
}
